import { Box, Typography } from '@mui/material';
import { useId } from 'react';
import { CustomeSlide } from '../../../../core/CustomeSlide';
import { useDialogContext } from '../../../../core/DialogPresenter/DialogContext';
import { useRegisterDialogPage } from '../../../../core/DialogPresenter/useRegisterDialogPage';
import { NavRow } from '../../generic/NavRow';
import { nil } from '../../generic/utilities';

type ITestamentStartProps = unknown;

export function TestamentStart(_: ITestamentStartProps) {
  const id = useId();
  const { handleNext, handleBack } = useDialogContext();

  const pageNumber = useRegisterDialogPage(id, {
    title: 'Start',
  });

  if (nil(pageNumber)) {
    return null;
  }

  return (
    <CustomeSlide key={id} pageNumber={pageNumber} appear={false}>
      <Box>
        <Box sx={{ mt: 5 }} />
        <Typography variant='h4' sx={{ mb: 3 }}>
          Testament
        </Typography>

        <Typography>
          Herzlich willkommen!
          <br />
          Mit Hilfe unseres Dialogs können Sie die Erstellung oder Bearbeitung
          ihres Testaments vorbereiten.
          <p />
          Brauchen Sie zwischendurch eine Pause? Sie können Ihre Eingaben
          jederzeit über das Feld <i>Sichern</i> exportieren und speichern.
          Setzen Sie Ihre Eingaben dann über die Klickfläche{' '}
          <i>Wiederherstellung</i> fort.
        </Typography>

        <NavRow
          handleBack={handleBack}
          handleNext={handleNext}
          hideBackButton
        />
      </Box>
    </CustomeSlide>
  );
}
